<!-- <cx-navigation-ui [node]="node$ | async" [ngClass]="styleClass$ | async" [flyout]="false"> </cx-navigation-ui> -->
@if ((node$ | async)?.children[0]; as nodes) {
  <ul id="accordion" class="accordion">
    @for (menu of nodes.children; track menu; let i = $index) {
      <li [class.active]="menu.active">
        @if (menu.url) {
          <div class="menu" (click)="toggle(menu, i)" [class.highlight-menu]="menu.isCurrentUrl">
            <cx-generic-link
              [class]="menu.children && menu.children.length > 0 ? 'd-inline-block' : 'd-flex'"
              [url]="menu.url"
              [target]="menu.target"
              >
              @if (menu.media) {
                <cx-media [container]="menu.media"></cx-media>
              }
              <div>
                {{ menu.title }}
              </div>
            </cx-generic-link>
            @if (menu.children && menu.children.length > 0) {
              <i class="fa"></i>
            }
          </div>
        }
        @if (menu.children && menu.children.length > 0) {
          <ul
            class="submenu"
            #submenu
            [style.height.px]="menu.active ? submenu.scrollHeight : 0"
            >
            @for (submenu of menu.children[0].children; track submenu) {
              <li [class.highlight-menu]="submenu.isCurrentUrl">
                <cx-generic-link class="d-block" [url]="submenu.url" [target]="submenu.target">
                  @if (submenu.media) {
                    <cx-media [container]="submenu.media"></cx-media>
                  }
                  {{ submenu.title }}
                </cx-generic-link>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
}
